// Cart URL Fix - Intercepts fetch requests to wrong cart URL
// Version: 2.0 - {{ 'now' | date: '%s' }}
(function() {
  'use strict';
  
  // Store original fetch
  var originalFetch = window.fetch;
  
  // Override fetch
  window.fetch = function(url, options) {
    var fixedUrl = url;
    
    // Check if URL is a string and contains the wrong cart path
    if (typeof url === 'string') {
      if (url.indexOf('/products/cart') !== -1) {
        fixedUrl = url.replace(/\/products\/cart\b/g, '/cart/add');
        console.log('[Cart Fix] URL corrected:', fixedUrl);
      }
    }
    
    // Call original fetch with fixed URL
    return originalFetch.call(this, fixedUrl, options);
  };
  
  console.log('[Cart Fix] Loaded successfully');
})();

